import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import { BasicPrivilegeItem } from '../PrivilegeConfig.types';
import { BasicPrivilegeDefaultView } from './BasicPrivilegeDefaultView';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { BasicPrivilegeContainer } from '../partials/BasicPrivilegeContainer';
import { CollapsibleBlock, CollapsibleBlockModifier } from '../../../components/molecules/CollapsibleBlock';

type BasicPrivilegeConfigDefaultViewProps = {
  privileges: BasicPrivilegeItem[];
};

export function BasicPrivilegeConfigDefault({ privileges }: BasicPrivilegeConfigDefaultViewProps) {
  const { t } = useSonTranslation('PrivilegeConfig');

  return (
    <>
      {privileges.map((privilege) => {
        const privilegeTitle = t(`headline.${privilege.privilegeType.toLowerCase()}` as any);

        return (
          <BasicPrivilegeContainer key={privilege.privilegeType} privilege={privilege} privilegeLabel={privilegeTitle}>
            <CollapsibleBlock
              id={privilege.privilegeType}
              title={t('includedPageTypes', { name: privilegeTitle })}
              closed={true}
              modifier={[CollapsibleBlockModifier.LIGHT, CollapsibleBlockModifier.NO_BORDER]}
              hierarchy={4}
            >
              <BasicPrivilegeDefaultView {...privilege} />
            </CollapsibleBlock>
          </BasicPrivilegeContainer>
        );
      })}
    </>
  );
}

export const BasicPrivilegeConfigDefaultView = asView(BasicPrivilegeConfigDefault);
export type BasicPrivilegeConfigDefaultView = ComponentProps<typeof BasicPrivilegeConfigDefaultView>;
